module.exports = __webpack_public_path__ + "static/media/Vectorchat.038b8e49.svg";